var $a3d99ea5d46a3d12$exports = {};
$a3d99ea5d46a3d12$exports = {
  "pending": `\u{432} \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{456}`
};
export { $a3d99ea5d46a3d12$exports as default };